import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';
import { simplifyQueryValue } from 'js/lib/queryUtils';
import { useLocation } from 'js/lib/useRouter';

import Naptime from 'bundles/naptimejs';
import EnterpriseDiscretionaryDiscounts from 'bundles/naptimejs/resources/enterpriseDiscretionaryDiscounts.v1';
import type { DiscretionaryDiscount } from 'bundles/naptimejs/resources/enterpriseDiscretionaryDiscounts.v1';

export type WithRouterDiscretionaryDiscountCodeProps = {
  discretionaryDiscountCode?: string;
};

export type WithDiscretionaryDiscountProps = {
  discretionaryDiscount?: DiscretionaryDiscount;
};

/** @deprecated use useRouterDiscretionaryDiscountCode instead */
export const withRouterDiscretionaryDiscountCode = compose<WithRouterDiscretionaryDiscountCodeProps, {}>(
  connectToRouter<WithRouterDiscretionaryDiscountCodeProps, {}>((router) => {
    const discretionaryDiscountCode = router.location.query?.dd;

    return {
      discretionaryDiscountCode,
    };
  })
);

export const useRouterDiscretionaryDiscountCode = (): WithRouterDiscretionaryDiscountCodeProps => {
  const location = useLocation();
  const discretionaryDiscountCode = location.query?.dd;
  return { discretionaryDiscountCode: simplifyQueryValue(discretionaryDiscountCode) };
};

export const withDiscretionaryDiscount = compose<
  WithDiscretionaryDiscountProps,
  WithRouterDiscretionaryDiscountCodeProps
>(
  Naptime.createContainer<WithDiscretionaryDiscountProps, WithRouterDiscretionaryDiscountCodeProps>(
    ({ discretionaryDiscountCode }: WithRouterDiscretionaryDiscountCodeProps) => {
      return {
        discretionaryDiscount: discretionaryDiscountCode
          ? EnterpriseDiscretionaryDiscounts.get(
              discretionaryDiscountCode,
              {
                fields: ['id', 'purchaserUserId', 'licenseCount', 'expiresAt', 'appliedAt'],
                required: false,
              },
              (
                discretionaryDiscount:
                  | Pick<DiscretionaryDiscount, 'id' | 'purchaserUserId' | 'licenseCount' | 'expiresAt' | 'appliedAt'>
                  | undefined
              ) => {
                return discretionaryDiscount;
              }
            )
          : undefined,
      };
    }
  )
);

export default withDiscretionaryDiscount;
